
export class ExportCsvRequest {
  //templateName: string;
  withHeader: boolean;
  withQuotes: boolean;
  storeData: string | null = null;
  delimiter: string | null = null;
  encoding: string | null = null;

  constructor(withHeader: boolean, storeData: string | null = null, withQuotes: boolean = false, delimiter: string | null = "", encoding: string | null = "") {
    this.withHeader = withHeader;
    this.storeData = storeData;
    this.withQuotes = withQuotes;
    this.delimiter = delimiter ? delimiter : "";
    this.encoding = encoding ? encoding :  "";
  }
}
